@if (show) {
  <div class="row">
    <div id="cookie-info" class="col">
      <div class="d-none d-lg-block">
        <p class="text-center">
          {{ 'COOKIE_TEXT' | translate }}
          <button class="btn btn-active ml-3" (click)="ok()">{{ 'COOKIE_BTN' | translate }}</button>
        </p>
      </div>
      <div class="d-block d-lg-none">
        <div class="row">
          <div class="col-sm-9">
            <p>
              {{ 'COOKIE_TEXT' | translate }}
            </p>
          </div>
          <div class="col-12 col-sm-3">
            <button class="btn btn-active mx-auto d-block" (click)="ok()">{{ 'COOKIE_BTN' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
